import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  labelColor?: string;
}

export const Root = styled.div`
  z-index: 300;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.45);
  font-family: Roboto;
`

export const BoxContainer = styled.div`
  position: relative;
  width: calc(650px);  
  padding: 0px 0px 86px 0px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 6px;
`

export const TitleContainer = styled.div`
  height: 96px;
  padding: 0px 60px 0px 60px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #272727;
  background-color: rgba(18, 36, 66, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const LeftSide = styled.div`
`

export const Title = styled.div`
  padding: 0px 0px 11px 0px;
  text-transform: capitalize;
`

export const SubtitleContainer = styled.div`
  display: flex;
`


export const Content = styled.div`
  
  padding: 24px 60px;
`
export const Description = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  margin-bottom: 47px;
`;

export const ActionsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 60px;
  bottom: 48px;
`

export const Error = styled.div`
  font-weight: bold;
  margin-right: 6px;
`

export const Action = styled.div`
  min-width: 112px;
`

export const SummaryMessage = styled.div`
font-size: 18px;
font-weight: normal;
font-stretch: normal;
font-style: normal;
letter-spacing: normal;
text-align: left;
color: #000;
`;

export const  Summary = styled.ul`

`

export const SummaryText = styled.li`

`
